export default {
  legalInfoApi: {
    //网站
    legalInfo: {
      getList: 'api/screen/legalInfo/legalInfoList',
      saveLegalInfo: 'api/screen/legalInfo/saveLegalInfo',
      updateLegalInfo: 'api/screen/legalInfo/updateLegalInfo',
      delLegalInfo: 'api/screen/legalInfo/delLegalInfo',
    }

  }
}
